import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";
import Logo from "../resources/logo.png";

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1
  },
  title: {
    flexGrow: 1
  },

  marginRight: {
    marginRight: theme.spacing(1),
    color: "white"
  },

  logo: {
    height: theme.spacing(5)
  }
}));

export default function NavBar() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <AppBar position="fixed" color="default" className={classes.appBar}>
        <Toolbar>
          <Link to="/">
            <img src={Logo} className={classes.logo} />
          </Link>
          <div className={classes.title} />
          <Button
            component={Link}
            to="/rooms"
            variant="outlined"
            color="primary"
            className={classes.marginRight}
          >
            Live Directory
          </Button>
          <Button component={Link} to="/" variant="outlined">
            Sign up
          </Button>
        </Toolbar>
      </AppBar>
    </div>
  );
}
